<template>
	<div class="token-list">
		<Table
			:columns="columns"
			:rows="tokens"
			:loadingMore="false"
			:loadingOverlay="false"
		>
			<template #cell-name="{ data }">
				<div class="name-column">
					<div class="name">{{ data.name }}</div>
					<div class="created-at">
						{{
							$t('settings_apitokens_created', {
								Date: dateFormat(data.created_at, 'L'),
							})
						}}
					</div>
				</div>
			</template>

			<template #cell-lastused_at="{ data }">
				<div class="last-used">
					<div>
						{{
							data.lastused_at
								? dateFormat(data.lastused_at, 'L')
								: $t('settings_apitokens_never_used')
						}}
					</div>
					<div v-if="data.lastusedip" class="ip-address">
						{{ $t('settings_apitokens_from', { IPAddress: data.lastusedip }) }}
					</div>
				</div>
			</template>

			<template #cell-scopes="{ data }">
				<div class="scopes">{{ joinScopes(data.scopes) }}</div>
			</template>

			<template #cell-revoke="{ data }">
				<Button danger small @click="$emit('revoke', data)">
					{{
						data.active
							? $t('settings_apitokens_revoke')
							: $t('settings_apitokens_expired')
					}}
				</Button>
			</template>
		</Table>
	</div>
</template>

<script>
import { getTokensByValues } from './apitokens'
import { dateFormat } from '@/helperMethods'
import { Table, Button } from '@/components/common'

export default {
	components: { Table, Button },

	data() {
		return {
			columns: [
				{
					field: 'name',
					label: this.$t('groupsettings_option_name'),
					width: '400px',
					minWidth: '200px',
				},
				{
					field: 'lastused_at',
					label: this.$t('settings_apitokens_last_used'),
					width: '300px',
				},
				{
					field: 'scopes',
					label: this.$t('settings_apitokens_scopes'),
				},
				{
					field: 'revoke',
					minWidth: '150px',
					align: 'right',
				},
			],
		}
	},

	emits: ['revoke'],

	computed: {
		tokens() {
			return getTokensByValues().sort((a, b) => {
				return new Date(b.created_at) - new Date(a.created_at)
			})
		},
	},

	methods: {
		dateFormat,

		joinScopes(scopes) {
			scopes = Array.isArray(scopes) ? scopes : JSON.parse(scopes)
			return scopes.join(', ')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.token-list {
	.header {
		display: flex;
		background-color: #fafafa;
		border-radius: 10px 10px 0 0;
		padding: 10px 0;
		border-bottom: 1px solid #e2e4e6;

		.header-name {
			width: 260px;
			padding-left: 24px;
		}

		.header-last-used {
			width: 200px;
			padding-left: 48px;
		}

		.header-scopes {
			padding-left: 34px;
		}
	}
}

.name-column {
	max-width: 100%;

	.name {
		font-family: 'Avenir-Heavy';
		font-size: 15px;
		color: #4f5053;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.created-at {
		font-family: 'Avenir-Medium';
		font-size: 12px;
		color: var(--neutral-600);
	}
}

.last-used {
	font-family: 'Avenir-Medium';
	font-size: 12px;
	color: #4f5053;

	.ip-address {
		font-size: 12px;
		color: var(--neutral-600);
	}
}

.scopes {
	font-family: 'Avenir-Medium';
	font-size: 14px;
	color: #4f5053;
	display: block !important;
	-webkit-line-clamp: unset !important;
	-webkit-box-orient: unset !important;
	overflow: visible !important;
}

.revoked {
	border-radius: unset;
	background-color: unset;
	padding: 0;
	color: var(--neutral-800);
	cursor: default;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.token-list {
		.pronto-table {
			.table-body {
				background: transparent;
			}

			.table-row .table-cell {
				color: var(--neutral-600);
			}

			.table-row .table-cell .name,
			.table-row .table-cell .last-used,
			.table-row .table-cell .scopes {
				color: var(--neutral-800);
			}
		}
	}
}
</style>
